import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

try {
  const root = createRoot(rootElement);
  root.render(<App />);
} catch (error) {
  console.error("Error rendering app:", error);
  rootElement.innerHTML = `
    <div style="
      padding: 20px;
      color: #dc2626;
      font-family: system-ui, -apple-system, sans-serif;
      max-width: 600px;
      margin: 40px auto;
      background: #fee2e2;
      border-radius: 8px;
      border: 1px solid #fecaca;
    ">
      <h1 style="font-size: 20px; margin-bottom: 16px;">Error Loading Application</h1>
      <p style="margin-bottom: 16px;">There was an error loading the application. Please try refreshing the page.</p>
      <pre style="
        background: #f8fafc;
        padding: 16px;
        border-radius: 4px;
        overflow: auto;
        font-size: 14px;
      ">${error instanceof Error ? error.message : String(error)}</pre>
    </div>
  `;
}
